import { HTMLAttributes, ReactNode } from 'react'

interface ViewOnlyWrapperProps extends HTMLAttributes<HTMLDivElement> {
    children: ReactNode
    disableEvents: boolean
    className?: string
}

export const ViewOnlyWrapper = ({
    children,
    disableEvents,
    className,
    ...rest
}: ViewOnlyWrapperProps) => {
    const handleKeyDown = (event: any) => {
        if (disableEvents) {
            event.preventDefault()
        }
    }

    return (
        <div
            onKeyDown={handleKeyDown}
            className={`${disableEvents && 'viewOnly'} ${className}`}
            {...rest}
        >
            {children}
        </div>
    )
}